import { Typography } from '@material-ui/core'

import { getTranslate } from '../../localization'
import { RatePlanBrief } from '../../types/rateplan'
import RatePlanRowMobile from './RateplanRowMobile'
import RateplanRowMobileSkeleton from './RateplanRowMobile.skeleton'
import useStyles from './styles/RateplansTable.styles'

interface RateplansTableMobileProps {
  loading: boolean
  data: RatePlanBrief[]
  roomTypeid: string
  hasAccessToViewRatePlanTabs: boolean | undefined
}
export const RateplansTableMobile: React.FC<RateplansTableMobileProps> = ({
  loading,
  data,
  roomTypeid,
  hasAccessToViewRatePlanTabs
}) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.tableHeadMobile}>
        <div className={classes.tableHeadCellMobile}>
          <Typography variant="body1">{getTranslate('Name')}</Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('Code')}</Typography>
        </div>
      </div>
      {loading
        ? Array(5)
            .fill(null)
            .map((nullItem, index) => (
              <RateplanRowMobileSkeleton
                key={`rateplanrow-mobile-skeleton${index.toString()}`}
              />
            ))
        : data.map((singleRatePlan, index) => (
            <RatePlanRowMobile
              key={index}
              hasAccessToViewRatePlanTabs={hasAccessToViewRatePlanTabs}
              data={singleRatePlan}
              roomTypeid={roomTypeid}
            />
          ))}
    </div>
  )
}
